module.exports = __webpack_public_path__ + "img/frankford_logo_login.f171b122.svg";